import { render, staticRenderFns } from "./account-container.vue?vue&type=template&id=2d340ada&scoped=true"
import script from "./account-container.vue?vue&type=script&lang=js"
export * from "./account-container.vue?vue&type=script&lang=js"
import style0 from "./account-container.vue?vue&type=style&index=0&id=2d340ada&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d340ada",
  null
  
)

export default component.exports